import Plugin from '../core/plugin';
export default class NavigationPlugin extends Plugin {
    beforeConfig(config) {
        const level = this.getHashLevel();
        return Object.assign({}, config, { level });
    }
    init(view, state, dispatch) {
        this.update(view, state, dispatch);
    }
    update(view, state, dispatch) {
        if (!state.prev || state.level !== state.prev.level) {
            window.history.replaceState({}, document.title, `${window.location.href.split('#')[0]}#/kjuicer/${state.level}`);
        }
    }
    getHashLevel() {
        const hash = window.location.hash;
        if (hash.match(/^#\/kjuicer\/\d+$/)) {
            try {
                return parseInt(hash.split('/')[2], 10);
            }
            catch (error) {
                return 0;
            }
        }
        return 0;
    }
}
